import { createSlice } from '@reduxjs/toolkit';
import { DEFAULT_MOSCOW_REGION } from '../../constants/region';
import { ILocation } from '../../types/location/location';

const initialState: ILocation = {
  ...DEFAULT_MOSCOW_REGION,
};

export const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {},
});

export const { reducer: locationReducer } = locationSlice;
